import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';
import { WorkOrderLineItemRawDto } from './work-order-line-item-raw-dto';

export class WorkOrderRawDto {
    communityId: number;
    workOrderId: number;
    statusCode: string;
    priorityCode: string;
    responsibleId: string;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    dueDate: Date;

    jobTypeCode: string;
    referenceTypeCode: string;
    referenceId: string;
    authorizationAmount: number;
    specialInstructions: string;
    jobDescription: string;

    @Type(() => WorkOrderLineItemRawDto)
    lineItems: Array<WorkOrderLineItemRawDto>;
}
